import { LabelType } from '../../labels/main_labels'

export const getLabel = (elm: any, labels?: LabelType): string => {
  if (labels) {
    return labels.es[elm]
  }
  if (elm.name) return elm.name
  return elm
}
